import EventsSerializer from './base';

export default class Permission extends EventsSerializer {}
